<div class="container" *ngIf="!translationsLoading">
    <footer class="position-relative d-flex justify-content-end">
        <img src="/assets/img/misc/logo.svg" alt="logo">
    </footer>
</div>